import { render, staticRenderFns } from "./order.vue?vue&type=template&id=80e9f558&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e9f558')) {
      api.createRecord('80e9f558', component.options)
    } else {
      api.reload('80e9f558', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=80e9f558&", function () {
      api.rerender('80e9f558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/upgrade/components/order.vue"
export default component.exports